<div class="modal-header">
    <h2 class="modal-header__title">
        {{'app.folders.selTargetDir' | translate}}
    </h2>
    <div class="modal-header__close-link">
        <span class="close" [mat-dialog-close]></span>
    </div>
</div>
<ng-content select=".hint"></ng-content>
<div class="assets-management__wrapper">
    <div class="assets-management__breadcrumbs">
        <app-directory-breadcrumbs></app-directory-breadcrumbs>
    </div>
    <div class="assets-management__search">
        <button class="dw-btn dw-btn_icon" (click)="addFolder.emit()">
            <i class="hgi hgi-stroke hgi-folder-add icon__middle"></i>
            {{'app.folders.addFolder' | translate}}
        </button>
        <app-search
                class="search"
                searchStr]="search"
                (searchValue)="onFolderSearch.emit($event)"
                placeholder="{{'app.folders.searchByFoldersName' | translate}}"
        ></app-search>
    </div>
    <div class="assets-management__content">
        <ng-content select="app-modal-folder-item"></ng-content>
        <div class="assets-management__message">
            <ng-content select=".message"></ng-content>
        </div>
        <ng-content select="pagination-controls"></ng-content>
        <div class="assets-management__buttons">
            <ng-content select="button.dw-btn"></ng-content>
        </div>
    </div>
</div>
